import React, { useState } from 'react'

import { TtButton, TtIcon } from '@23/ui-react'

import { type WidgetDTO } from '../../../../../../model/Widget'
import { useVideoPreviewSettingsContext } from '../../../../VideoPreviewSettingsContext'

interface ButtonPreviewProps {
  widget: WidgetDTO
  isEditable: boolean
  handleEdit: () => void
  handleDelete: () => void
}

const ButtonPreview = ({
  widget,
  isEditable,
  handleEdit,
  handleDelete,
}: ButtonPreviewProps) => {
  const [showActions, setShowActions] = useState(false)
  const { scrubberColor } = useVideoPreviewSettingsContext()
  const label = widget.label || 'Button'

  return (
    <div
      className="personal-widget-button-wrapper"
      style={{ '--widget-brand-color': scrubberColor } as React.CSSProperties}
      onMouseEnter={() => isEditable && setShowActions(true)}
      onFocus={() => isEditable && setShowActions(true)}
      onMouseLeave={(e) => {
        const target = e.relatedTarget as Node | null
        if (!target || !e.currentTarget.contains(target)) {
          setShowActions(false)
        }
      }}
      onBlur={(e) => {
        const target = e.relatedTarget as Node | null
        if (!target || !e.currentTarget.contains(target)) {
          setShowActions(false)
        }
      }}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={isEditable ? 0 : undefined}
    >
      {isEditable && showActions && (
        <div className="personal-widget-button-actions">
          <TtButton
            color="secondary"
            variant="light"
            size="x-small"
            className="personal-widget-button-action personal-widget-button-action--delete"
            onClick={handleDelete}
            label="Delete"
          >
            <TtIcon library="one" name="bin" />
          </TtButton>
          <TtButton
            color="secondary"
            variant="light"
            size="x-small"
            className="personal-widget-button-action personal-widget-button-action--edit"
            onClick={handleEdit}
            label="Edit"
          >
            <TtIcon library="one" name="edit" />
          </TtButton>
        </div>
      )}
      <TtButton
        label={label}
        size="large"
        className="personal-widget-button"
        href={widget.link || undefined}
        target="_blank"
        rel="noopener noreferrer"
      >
        {label}
      </TtButton>
    </div>
  )
}

export { ButtonPreview }
